import './Step1.scss';

function calcEventDuration() {
    var pickerStart = window.kendoInstances.EventBegin
    var pickerEnd = window.kendoInstances.EventEnd

    var dateStart = pickerStart.value()
    var dateEnd = pickerEnd.value()

    var result = dateEnd - dateStart
    var time = (result / (1000 * 60 * 60))
    var value = time.toFixed(0)

    $('#eventDuration').removeClass()
    $('#eventDuration').text(value)

    if (value > 40) {
        $('#eventDuration').addClass('text-warning')
    }
    else if (value < 1) {
        $('#eventDuration').addClass('text-danger')
    }
}

window.selectRecentlyAddedLocation = function (id) {
    var dropDownList = $('#LocationId').data('kendoDropDownList')
    dropDownList.dataSource.read()
    dropDownList.refresh()
    dropDownList.value(id)
}

window.eventStartDateChanged = function (e) {
    var dateStart = this.value()
    var dateEndPicker = window.kendoInstances.EventEnd
    var targetDate = new Date(dateStart)
    targetDate.setDate(dateStart.getDate() + 1)
    targetDate.setHours(6)
    targetDate.setMinutes(0)
    targetDate.setSeconds(0)
    dateEndPicker.min(dateStart)
    dateEndPicker.value(dateStart)
    dateEndPicker.trigger("change")

    calcEventDuration()
}

window.eventEndDateChanged = function (e) {
    calcEventDuration()
}

$(function () {
    $('#submitBtn').click(() => {
        setTimeout(() => $('#submitBtn').prop('disabled', true), 100)
    })
})